import { useEffect, useState } from "react";
import { useLocation, useRoutes, type Location } from "react-router-dom";
import { useIsPc } from "@/shared/composables/useIsPc";
import { ScrollManager } from "@/shared/ui/ScrollManager";
import { SiteHeader } from "@/shared/ui/SiteHeader";
import { PUBLIC_ROUTES, registerModalRoutes } from "@/public/routes";
import "@/public/styles.css";

/** 수정은 비공개 카드에서도 열리므로 배경을 카드 상세가 아니라 목록으로 둔다. */
const REGISTER_FALLBACK: { match: RegExp; background: string }[] = [
  { match: /^\/problems\/new/, background: "/problems" },
  { match: /^\/problems\/[^/]+\/edit/, background: "/problems" },
];

function readRegisterFallback(pathname: string): string | null {
  return (
    REGISTER_FALLBACK.find((r) => r.match.test(pathname))?.background ?? null
  );
}

function pathLocation(pathname: string): Location {
  return { pathname, search: "", hash: "", state: null, key: "register-bg" };
}

function locationPath(location: Location | null): string {
  return location === null ? "/" : `${location.pathname}${location.search}`;
}

function useRegisterBackground(
  isPc: boolean,
  location: Location,
): Location | null {
  const fallback = readRegisterFallback(location.pathname);

  const [lastPage, setLastPage] = useState<Location | null>(null);
  useEffect(() => {
    if (readRegisterFallback(location.pathname) === null) setLastPage(location);
  }, [location]);

  if (!isPc || fallback === null) return null;
  return lastPage ?? pathLocation(fallback);
}

function RegisterModalRoutes({ closeTo }: { closeTo: string }) {
  return useRoutes(registerModalRoutes(closeTo));
}

export function PublicApp() {
  const location = useLocation();
  const isPc = useIsPc();
  const registerBackground = useRegisterBackground(isPc, location);

  const screen = useRoutes(PUBLIC_ROUTES, registerBackground ?? location);

  return (
    <>
      <SiteHeader />
      <ScrollManager />
      {screen}
      {registerBackground !== null && (
        <RegisterModalRoutes closeTo={locationPath(registerBackground)} />
      )}
    </>
  );
}
